// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics, IconBasket, IconLayoutKanban, IconNfc } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconBasket,
    IconLayoutKanban,
    IconNfc
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface DashboardMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}

const dashboardAdmin: DashboardMenuProps = {
    id: 'dashboard-admin',
    title: '',
    type: 'group',
    children: [
        {
            id: 'manage-application',
            title: <FormattedMessage id="manage-application" />,
            type: 'item',
            url: '/manage-application',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'manage-project',
            title: <FormattedMessage id="manage-project" />,
            type: 'item',
            url: '/manage-project',
            icon: icons.IconNfc,
            breadcrumbs: false
        },
        {
            id: 'project-stamp',
            title: <FormattedMessage id="info-nfts" />,
            type: 'item',
            url: '/admin/project-stamp',
            icon: icons.IconDeviceAnalytics,
            breadcrumbs: false
        },
    ]
};

export default dashboardAdmin;
